import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../Marcas/Marcas.css'; // Import the shared CSS

const MarcaForm = ({ initialData, onSubmit, loading, isEditing = false }) => {
    const [descricao, setDescricao] = useState('');

    useEffect(() => {
        if (initialData) {
            setDescricao(initialData.descricao || '');
        }
    }, [initialData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ descricao });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-card">
                <h5 className="form-section-header">Dados da Marca</h5>
                <div className="mb-3">
                    <label htmlFor="descricao" className="form-label-custom">Descrição</label>
                    <input
                        type="text"
                        className="form-control-custom"
                        id="descricao"
                        value={descricao}
                        onChange={(e) => setDescricao(e.target.value)}
                        required
                        placeholder=""
                    />
                </div>
            </div>

            {/* Fixed Footer Actions */}
            <div className="form-actions-bar">
                <Link to="/app/marcas" className="btn-secondary-custom">
                    Cancelar
                </Link>
                <button type="submit" className="btn-primary-custom" disabled={loading}>
                    {loading ? (isEditing ? 'Atualizando...' : 'Salvando...') : (isEditing ? 'Salvar Alterações' : 'Salvar Marca')}
                </button>
            </div>
        </form>
    );
};

export default MarcaForm;
